<div class="row mx-0 align-items-center justify-content-center px-0 py-3 calcHeight" *ngIf="profile">
    <form [formGroup]="alternateContact" class="h-100 mt-5">
        <div class="col-xl-9 col-12 px-xl-5 ms-xl-5">
        <div class="row">
            <div class="col-12 pb-2">
                <h3
                style=" font-weight: 700;font-size: 18px;margin-bottom: 1.5rem;display: flex; align-items: center;color: #313A44;">
                Alternate Contact
                </h3>
            </div>
        </div>
            <div class="row">
                <!-- Filed Starts -->
                <div class="col-12 mb-3">
                    <div
                        [ngClass]="[alternateContact.controls.alternate_name.touched && alternateContact.controls.alternate_name.invalid ? 'custom-form inputContainer' : 'custom-form']">
                        <input class="input_field px-3 pt-3" formControlName="alternate_name" required trim maxlength="100" />
                        <label for="text" class="label-name">
                            <span class="content-name f-c-p-3">
                                Name
                            </span>
                        </label>
                    </div>
                    <p class="mat-error mb-0"
                        *ngIf="alternateContact.controls.alternate_name.touched && alternateContact.controls.alternate_name.errors?.required ">
                        Please enter name.
                    </p>
                    <p class="mat-error mb-0"
                        *ngIf="alternateContact.controls.alternate_name.touched && alternateContact.controls.alternate_name.errors?.minlength">
                        Please enter valid name.
                    </p>
                    <p class="mat-error mb-0"
                        *ngIf="alternateContact.controls.alternate_name.touched && alternateContact.controls.alternate_name.invalid && alternateContact.controls.alternate_name.errors && alternateContact.controls.alternate_name.errors.pattern">
                        Please enter valid name.
                    </p>
                </div>
                <!-- Field Ends -->

                <!-- Filed Starts -->
                    <div class="col-12 mb-3">
                    <div
                        [ngClass]="[alternateContact.controls.alternate_phone && alternateContact.controls.alternate_phone.touched && alternateContact.controls.alternate_phone.invalid  ? 'custom-form flex-grow-1 me-md-3 inputContainer' : 'custom-form flex-grow-1 me-md-3']">
                        <span
                            *ngIf="alternateContact.controls.alternate_phone &&  (alternateContact.controls.alternate_phone.value !== null && alternateContact.controls.alternate_phone.value !== '')"
                            class="pt-2 pe-1 fw-bold dollar_input"
                        style="position: absolute;left: 14px;bottom: 8px;">+1</span>
                        <input class="input_field pt-3"
                            [ngStyle]="{'padding-left': alternateContact.value.alternate_phone !== '' ? '40px' : '1rem'}"
                            name="phone" [formControl]="alternateContact.controls['alternate_phone']" [mask]="mask"
                            required />
                        <label for="text" class="label-name">
                            <span class="content-name f-c-p-3">
                                Phone
                            </span>
                            <span *ngIf="profile.alternate_phone && !checkChanged(profile.alternate_phone,alternateContact.value.alternate_phone)" style="position: absolute; right: 0px;"
                                [ngStyle]="{'transform': profile.alternate_phone_verified ? 'translate(-21px, 22px)' : 'translate(-21px, 28px)'}">
                                <span class="d-flex align-items-center fs-18" [ngStyle]="{'color': profile.alternate_phone_verified ? '#20A9D3' : '#F77600'}">
                                    <img *ngIf="profile.alternate_phone_verified" class="me-1" [ngStyle]="{'height': !profile.alternate_phone_verified ? '15px' : '20px'}"
                                        [src]="profile.alternate_phone_verified ? '/assets/img/svg/verified_badge.svg' : '/assets/img/svg/verification_pending.svg'"
                                        alt="badge">

                                    {{!profile.alternate_phone_verified ? "Verification Pending" : 'Verified'}}</span>
                                <!-- <img style="
                                    position: absolute;
                                    right: -50px;
                                    top: 0px;
                                    height: 19px;
                                    cursor: pointer;
                                    z-index: 100;
                                " *ngIf="!profile.alternate_phone_verified" src="/assets/img/svg/info-circle-dark.svg" alt=""> -->
                            </span>
                        </label>
                    </div>
                    <p class="mat-error mb-0"
                        *ngIf="(alternateContact.controls.alternate_phone.touched && !alternateContact.controls.alternate_phone.errors?.pattern && alternateContact.controls.alternate_phone.value == '0000000000') || (alternateContact.controls.alternate_phone.touched && alternateContact.controls.alternate_phone.invalid) || (alternateContact.controls.alternate_phone.touched && alternateContact.controls.alternate_phone.invalid && alternateContact.controls.alternate_phone.errors?.required)">
                        Please enter valid Phone Number
                    </p>
                </div>
                <!-- Field Ends -->

                <!-- Filed Starts -->
                <div class="col-12 mb-3">
                    <div
                        [ngClass]="[alternateContact.controls.alternate_email.touched && alternateContact.controls.alternate_email.invalid ? 'custom-form inputContainer' : 'custom-form']">
                        <input class="input_field px-3 pt-3" formControlName="alternate_email" required trim maxlength="100" />
                        <label for="text" class="label-name">
                            <span class="content-name f-c-p-3">
                                Email Address
                            </span>

                            <span *ngIf="profile.alternate_email && !checkChanged(profile.alternate_email,alternateContact.value.alternate_email)" style="position: absolute; right: 0px;"
                                [ngStyle]="{'transform': profile.alternate_email_verified ? 'translate(-21px, 22px)' : 'translate(-21px, 28px)'}">
                                <span class="d-flex align-items-center fs-18" [ngStyle]="{'color': profile.alternate_email_verified ? '#20A9D3' : '#F77600'}">
                                    <img *ngIf="profile.alternate_email_verified" class="me-1" [ngStyle]="{'height': !profile.alternate_email_verified ? '15px' : '20px'}"
                                        [src]="profile.alternate_email_verified ? '/assets/img/svg/verified_badge.svg' : '/assets/img/svg/verification_pending.svg'"
                                        alt="badge">

                                    {{!profile.alternate_email_verified ? "Verification Pending" : 'Verified'}}</span>

                                <!-- <img style="
                                position: absolute;
                                right: -50px;
                                top: 0px;
                                height: 19px;
                                cursor: pointer;
                                z-index: 100;
                            " *ngIf="!profile.alternate_email_verified" src="/assets/img/svg/info-circle-dark.svg" alt=""> -->
                            </span>

                        </label>
                    </div>

                    <p class="mat-error mb-0"
                        *ngIf="alternateContact.controls.alternate_email.touched && alternateContact.controls.alternate_email.invalid">
                        Please enter Email Address.
                    </p>
                </div>
                <!-- Field Ends -->

                <!-- Filed Starts -->
                <div class="col-12 mb-4">
                    <div
                        [ngClass]="[alternateContact.controls.alternate_role.touched && alternateContact.controls.alternate_role.invalid ? 'custom-form inputContainer' : 'custom-form']">
                        <input class="input_field px-3 pt-3" formControlName="alternate_role" required trim maxlength="100" />
                        <label for="text" class="label-name">
                            <span class="content-name f-c-p-3">
                                Position/Role
                            </span>
                        </label>
                    </div>
                    <p class="mat-error mb-0"
                        *ngIf="alternateContact.controls.alternate_role.touched && alternateContact.controls.alternate_role.invalid">
                        Please enter Position/Role.
                    </p>
                </div>
                <!-- Field Ends -->

            </div>

                <div class="row">
                    <div class="col-12 pt-3">
                    <button type="submit" (click)="submitAlternateContact()" button-primary-auth class="me-3"
                        style="padding: 15px 45px;" [disabled]="!alternateContact.dirty">
                        Save
                    </button>
                    <button button-login-secondary (click)="openRemoveModal()"
                    *ngIf="profile && profile.alternate_name && profile.alternate_email" style="padding: 15px 45px;">
                        Remove
                    </button>
                    </div>
                </div>

                <!-- Verification dialogue -->
                <div class="row mt-4">
                    <div class="col-12 ">
                      <div class="bg-blue p-3 rounded">
<div class="d-flex align-items-center fs-20 heading mb-2">
                        <img src="assets/img/svg/info-circle_blue_filled.svg" alt="" style="height: 25px; margin-right: 8px;">
                        <span class="fw-600">Verification Process</span>
                    </div>
                    <div class="fw-400 fs-16" style="font-weight: 400 !important;color: #0C0D10;">
                        All communications, including emails and text messages related to your account, will be sent to both
                        your main account and the alternate contact, except for payout-related emails, which will only be
                        sent to the main account. Please ensure the alternate contact's information is up to date, and
                        that the alternate contact has consented to receive communications.
                    </div>
                      </div>  
                    
                    </div>
                </div>
        </div>
    </form>
</div>